import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const lowryParkConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Lowry Park Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Lowry Park, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_lowry_park',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Lowry Park',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Lowry Park Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide expert tree care to the 
     neighborhoods of <strong>Lowry Park</strong>. Situated along the Hillsborough 
     River in North Tampa, this community has the kind of lush, mature tree growth 
     that makes for beautiful streets but also creates consistent tree hazards. 
     Riverside properties deal with root instability from repeated flooding, 
     while inland homes face overgrown canopies that threaten rooftops and 
     driveways after every major storm.`,

    `We specialize in <strong>hazardous tree removal and riverside trimming</strong> 
     trees with root damage from flood prone soil, large overhanging limbs near 
     homes and garages, storm split trunks requiring emergency response, and 
     precision removals in tight residential lots close to the river. We handle 
     the full job and leave your property clean.`,

    `<strong>Sam's Tree Service</strong> delivers trusted, affordable tree care 
     throughout <strong>Lowry Park</strong> and the surrounding 
     <strong>North Tampa riverfront</strong> area protecting your property 
     and keeping your trees healthy all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Lowry Park, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_LowryPark = () => <LocationPage config={lowryParkConfig} />;
export default Services_LowryPark;
